import Link from 'next/link';

import Text from '@/components/ui/Text';
import type { ArticleDetail } from '@/lib/contentful/api/getArticle';

const NavLink = ({ article, locale, label, direction }: NavLinkProps) => {
  const isPrev = direction === 'prev';

  return (
    <Link
      href={`/${locale}/blog/${article.slug}`}
      className={`group flex items-center gap-3 max-w-[45%] ${isPrev ? '' : 'text-right'}`}
    >
      {isPrev && (
        <span className="text-2xl text-primary transition-transform group-hover:-translate-x-1">
          ←
        </span>
      )}
      <div>
        <Text as="p" variant="sectionEyebrow" className="mb-1">
          {label}
        </Text>
        <Text as="p" variant="paragraph" className="mb-0! line-clamp-2">
          {article.title}
        </Text>
      </div>
      {!isPrev && (
        <span className="text-2xl text-primary transition-transform group-hover:translate-x-1">
          →
        </span>
      )}
    </Link>
  );
};

export default NavLink;

export type AdjacentArticle = Pick<ArticleDetail, 'title' | 'slug'>;

type NavLinkProps = {
  article: AdjacentArticle;
  locale: string;
  label: string;
  direction: 'prev' | 'next';
};
